import { create } from "@mui/material/styles/createTransitions";

function toTitleCase(str) {
  return str.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
}


function convertJSONToQuestions(json,required_fields) {
  const questions_list = [];

  for (const key in json) {
    const question = json[key];

    const questionObj = {
      question_title: toTitleCase(key),
    };

    if (question.type === "object" && !question.enum) {
      // This is a section
      questionObj.choose_questions = "section";
      questionObj.section_title = question.title;
      questionObj.questions_section = convertJSONToQuestions(question.properties);
    } else if (question.type === "object" && question.dependencies) {
      // This is a dynamic-dropdown
      questionObj.choose_questions = "dynamic-dropdown";
      questionObj.section_title = question.title;
      questionObj.question_title = toTitleCase(Object.keys(question.properties)[0]);
      questionObj.questions_section = question.dependencies[Object.keys(question.dependencies)[0]].oneOf.map(item => ({
        question_options: item.properties[Object.keys(item.properties)[0]].enum,
        questions: convertJSONToQuestions(item.properties)
      }));
    } else {

      questionObj.question_heading = question.title;
      
      switch (question.type) {
        case "string":
          if (question.enum) {
            questionObj.choose_questions = "single select";
            questionObj.question_options = question.enum;
            questionObj.question_type = question["ui:widget"] === "radio" ? undefined : "dropdown";
          } else {
            questionObj.choose_questions = "text";
            questionObj.regex = question.pattern;
            questionObj.question_options = question.examples || [];
          }
          break;
        case "number":
          questionObj.choose_questions = "number";
          questionObj.question_minimum_limit = question.minimum;
          questionObj.question_maximum_limit = question.maximum;
          break;
        case "array":
          if (question.items && question.items.format === "data-url") {
            questionObj.choose_questions = "media";
            questionObj.question_required = question.file_required === true ? "Yes" : "No";
            questionObj.question_media_type = question.media;
            questionObj.question_max_files = question.maxItems;
            questionObj.question_extra_info = question.extraInfo;
          } else {
            questionObj.choose_questions = "multi-select";
            questionObj.question_options = question.items.enum;
            questionObj.question_required = question.minItems;
            questionObj.question_type = question["ui:widget"] === "checkboxes" ? undefined : "dropdown";
          }
          break;
      }
      
      if (required_fields && required_fields.includes(key)) {
        questionObj.question_required = "Yes";
      }

    }

    questions_list.push(questionObj);
  }

  return questions_list;
}

function convertQuestionsToJSON(
  questions,
  requiredQuestion,
  ui_schema_array,
  parentPath = ""
) {
  const result = {};

  for (const key in questions) {
    const question = questions[key];
    const path = parentPath
      ? `${parentPath}.${question.question_title}`
      : question.question_title;

    if (question.choose_questions === "section") {
      const path = parentPath
        ? `${parentPath}.${question.section_title}`
        : question.section_title;

      result[toSnakeCase(question.section_title)] = {
        type: "object",
        title: question.section_title,
        properties: convertQuestionsToJSON(
          question.questions_section,
          requiredQuestion,
          ui_schema_array,
          toSnakeCase(path)
        ),
        required: [],
      };
    } else if (question.choose_questions === "dynamic-dropdown") {
      const path = parentPath
        ? `${parentPath}.${question.section_title}.${question.question_title}`
        : `${question.section_title}.${question.question_title}`;

      let data = createDynamicDropdownDependency(
        question.questions_section,
        toSnakeCase(question.question_title),
        ui_schema_array,
        toSnakeCase(path),
        requiredQuestion
      );

      result[toSnakeCase(question.section_title)] = {
        type: "object",
        title: question.section_title,
        properties: {
          [toSnakeCase(question.question_title)]: {
            type: "string",
            title: question.question_title,
            enum: data.allOptions,
          },
        },
        dependencies: {
          [toSnakeCase(question.question_title)]: {
            oneOf: data.dependencies,
          },
        },
        required: [],
      };
    } else if (question.choose_questions === "text") {
      result[toSnakeCase(question.question_title)] = {
        type: "string",
        title: question.question_heading,
        pattern: question.regex
      };

      if (question?.question_options?.length > 0) {
        result[toSnakeCase(question.question_title)] = {
          ...result[toSnakeCase(question.question_title)],
          examples: question.question_options,
        };
      }
      if (question.question_required === "Yes") {
        requiredQuestion.push(toSnakeCase(path));
      }
    } else if (question.choose_questions === "single select") {
      result[toSnakeCase(question.question_title)] = {
        type: "string",
        title: question.question_heading,
        enum: question.question_options,
      };
      if (question.question_required === "Yes") {
        requiredQuestion.push(toSnakeCase(path));
      }
      if (question?.question_type !== "dropdown") {
        ui_schema_array.push({
          path: toSnakeCase(path),
          type: "radio",
        });
      }
    } else if (question.choose_questions === "number") {
      result[toSnakeCase(question.question_title)] = {
        type: "number",
        title: question.question_heading,
        minimum: question.question_minimum_limit
          ? question.question_minimum_limit
          : -1000000,
        maximum: question.question_maximum_limit
          ? question.question_maximum_limit
          : 1000000,
      };
      if (question.question_required === "Yes") {
        requiredQuestion.push(toSnakeCase(path));
      }
    } else if (question.choose_questions === "multi-select") {
      result[toSnakeCase(question.question_title)] = {
        type: "array",
        title: question.question_heading,
        minItems: question.question_required,
        uniqueItems: true,
        items: {
          type: "string",
          enum: question.question_options,
        },
      };
      if (question?.question_type !== "dropdown") {
        ui_schema_array.push({
          path: toSnakeCase(path),
          type: "checkboxes",
        });
      }
    } else if (question.choose_questions === "media") {
      result[toSnakeCase(question.question_title)] = {
        type: "array",
        items: {
          type: "string",
          format: "data-url",
        },
        media: question.question_media_type,
        title: question.question_heading,
        file_required: question.question_required === "Yes",
        path: toSnakeCase(path),
        maxItems: question.question_max_files,
        extraInfo: question.question_extra_info,
      };
    }
  }

  console.log(result);

  return result;
}

function createDynamicDropdownDependency(
  optionArray,
  questionTitle,
  uiSchemaArray,
  parentPath,
  requiredQuestion
) {
  const allQuestionOptions = optionArray
    .map((item) => item.question_options)
    .flat();
  let final_result = [];

  optionArray.forEach((item) => {
    let result = {
      properties: {
        [questionTitle]: {
          enum: item.question_options,
        },
      },
      required: [],
    };

    let requiredQuestionHere = [];

    let questionResult = convertQuestionsToJSON(
      item.questions,
      requiredQuestionHere,
      uiSchemaArray
    );

    result.properties = {
      ...result.properties,
      ...questionResult,
    };

    applyMandatoryForAll(result, requiredQuestionHere);
    final_result.push(result);
  });

  return { allOptions: allQuestionOptions, dependencies: final_result };
}
function applyMandatory(result, requiredQuestion) {
  const keys = requiredQuestion.split(".");
  let currentLevel = result;

  // Traverse through the path in the requiredQuestion
  for (let i = 0; i < keys.length - 1; i++) {
    const key = keys[i];

    if (currentLevel.properties && currentLevel.properties[key]) {
      currentLevel = currentLevel.properties[key];
    } else {
      // If the path does not exist in the JSON structure, we can return early or throw an error
      throw new Error(`Invalid path: ${requiredQuestion}`);
    }
  }

  // The last key in the path is the one to be added to the required array
  const finalKey = keys[keys.length - 1];

  // Initialize the required array if it does not exist
  if (!currentLevel.required) {
    currentLevel.required = [];
  }

  // Add the final key to the required array if it's not already present
  if (!currentLevel.required.includes(finalKey)) {
    currentLevel.required.push(finalKey);
  }
}

function applyMandatoryForAll(result, requiredQuestions) {
  requiredQuestions.forEach((requiredQuestion) => {
    applyMandatory(result, requiredQuestion);
  });
}

function buildUISchemaJson(paths) {
  const result = {};

  paths.forEach(({ path, type }) => {
    const keys = path.split(".");
    let currentLevel = result;

    // Traverse and create nested structure
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];

      if (i === keys.length - 1) {
        // Assign the type to the final property
        currentLevel[key] = {
          "ui:widget": type,
        };
      } else {
        // Create the nested structure if it doesn't exist
        if (!currentLevel[key]) {
          currentLevel[key] = {};
        }
        currentLevel = currentLevel[key];
      }
    }
  });

  return result;
}

function toSnakeCase(str) {
  return str.replace(/\s+/g, "_").toLowerCase();
}

export { convertQuestionsToJSON, applyMandatoryForAll, buildUISchemaJson , convertJSONToQuestions};
